import { Api } from './api';

export class ChallengesApi {
    private static readonly PATH = '/challenges';

    constructor(private readonly m_api: Api) {}

    public async get() {
        return this.m_api.get(ChallengesApi.PATH);
    }

    public async action(challengeId: number) {
        return this.m_api.post(`${ChallengesApi.PATH}/action`, { challengeId });
    }
}